
import { defineComponent } from 'vue'
export default defineComponent({
  emits: ['click'],
  name: 'Button',
  props: {},
  setup(props, { emit }) {
    return {}
  }
})
